/* eslint-disable no-unused-vars */
/**
 * @typedef {Object} DisputeTimesheetDetailsType
 * @property {Date} submittedDateUtc - Date timesheet was submitted
 * @property {TimesheetModificationsViewModel} modifications - List of modifications changing the original booking times
 */

import dayjs from '@/services/date/index'
import TimesheetModificationsViewModel from './timesheetModificationsViewModel'

/**
 * @class
 */
export default class DisputeTimesheetDetails {
  /**
   * Create a new DisputeTimesheetDetails.
   * @param {DisputeTimesheetDetailsType} params
   */
  constructor(params) {
    this.submittedDateUtc = params.submittedDateUtc
      ? dayjs(params.submittedDateUtc)
      : null
    this.modifications = params.modifications
      ? new TimesheetModificationsViewModel(params.modifications)
      : null
  }
}
